import {take, call, put} from 'redux-saga/effects';
import {
	fetchDeliveryStatusDetail,
	failFetchDeliveryStatusDetail,
	setDeliveryStatusDetailData,
	fetchCsvDataDeliveryStatusDetail,
	failFetchCsvDataDeliveryStatusDetail,
	setCsvDataDeliveryStatusDetail,
	getPdfItemsDeliveryStatus,
	failGetPdfItemsDeliveryStatus,
	setPdfItemsDeliveryStatus,
	getPdfItemsDeliveryStatusMod,
	failGetPdfItemsDeliveryStatusMod,
	setPdfItemsDeliveryStatusMod,
	getPdfItemsDeliveryStatusSecom, failGetPdfItemsDeliveryStatusSecom, setPdfItemsDeliveryStatusSecom

} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleFetchDeliveryStatusDetail() {
	while (true) {
		const action = yield take(`${fetchDeliveryStatusDetail}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'delivery-status-detail/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchDeliveryStatusDetail({err: msg}));
			continue;
		}
		yield put(setDeliveryStatusDetailData(Object.assign({}, payload, {})));
	}
}

export function* handleFetchCsvDataFromDeliveryStatusDetail() {
	while (true) {
		const action = yield take(`${fetchCsvDataDeliveryStatusDetail}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-csv-delivery-status/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchCsvDataDeliveryStatusDetail({err: msg}));
			continue;
		}
		yield put(setCsvDataDeliveryStatusDetail(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfDeliveryStatusDetail() {
	while (true) {
		const action = yield take(`${getPdfItemsDeliveryStatus}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-delivery-status/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsDeliveryStatus({err: msg}));
			continue;
		}
		yield put(setPdfItemsDeliveryStatus(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfDeliveryStatusMod() {
	while (true) {
		const action = yield take(`${getPdfItemsDeliveryStatusMod}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-delivery-status-mod/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsDeliveryStatusMod({err: msg}));
			continue;
		}
		yield put(setPdfItemsDeliveryStatusMod(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfDeliveryStatusSecom() {
	while (true) {
		const action = yield take(`${getPdfItemsDeliveryStatusSecom}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-receipt-secom/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsDeliveryStatusSecom({err: msg}));
			continue;
		}
		yield put(setPdfItemsDeliveryStatusSecom(Object.assign({}, payload, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/delivery-status-detail.js